import React from 'react';

const MailFillSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 13.9L2 5.7V19h20V5.7l-10 8.2z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.7 5l9.3 7.6L21.3 5z"
        />
    </svg>
);

MailFillSvg.displayName = 'MailFillSvg';
export default MailFillSvg;
